export default "__VITE_PUBLIC_ASSET__f08f3d13__"